module.exports = __webpack_public_path__ + "img/Tiny-but-mighty.ff9305f2.png";